"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUser = exports["default"] = void 0;

var _reselect = require("reselect");

var _app = require("../nicbase-navigation/app.actions");

var _user = require("./user.actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = {
  isAuthenticated: false
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _user.UPDATE_USER_PROFILE_REQUEST:
    case _user.UPDATE_USER_PROFILE_SUCCESS:
    case _user.FIND_USER_PROFILE_SUCCESS:
      {
        var user = action.body.user;
        return _objectSpread(_objectSpread({}, state), user);
      }

    case _user.AUTHENTICATE_USER_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAuthenticated: true
      });

    case _user.AUTHENTICATE_USER_ERROR:
    case _app.NICPLACE_LOGIN_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAuthenticated: false
      });

    default:
      return state;
  }
};

exports["default"] = _default;
var getUser = (0, _reselect.createSelector)([function (state) {
  return state.user;
}], function (user) {
  return user;
});
exports.getUser = getUser;